
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NavigationRow.html?raw';
import NavigationTile from './NavigationTile';

class NavigationRow extends compose(NavigationTile) {
    templateString: any = template;


    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

   

}

export default mdsWidget(NavigationRow);